import { Skeleton, Column, Row } from 'components/Blocks';

export function LoadingForm() {
  return (
    <Column>
      <Row>
        <Skeleton height={36} width={36} />
      </Row>

      <Skeleton quantity={5} height={36} />

      <Skeleton
        quantity={3}
        orientation="horizontal"
        height={100}
        width={220}
        wrapperClassName="phone:flex-col phone:items-stretch"
      />
    </Column>
  );
}
